import * as React from "react";
import {Box, HStack, Text} from "@chakra-ui/react";

type SoundSpotsLogoProps = {
    size?: number
    color?: string
    accent?: string
}

const ArcMark = ({size, accent}: {size: number; accent: string}) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <circle cx="24" cy="34" r="2.8" fill={accent}/>
        <path d="M15 35.94 A9 9 0 0 1 33 35.94" stroke={accent} strokeWidth="1.3" fill="none" strokeLinecap="round" opacity="0.9"/>
        <path d="M10 34.85 A14 14 0 0 1 38 34.85" stroke={accent} strokeWidth="1.0" fill="none" strokeLinecap="round" opacity="0.5"/>
        <path d="M5 33.30 A19 19 0 0 1 43 33.30" stroke={accent} strokeWidth="0.9" fill="none" strokeLinecap="round" opacity="0.42"/>
        <path d="M5 35.5 Q24 42.3 43 35.5" stroke={accent} strokeWidth="1.0" fill="none" strokeLinecap="round" opacity="0.5"/>
    </svg>
);

const SoundSpotsLogo = ({
    size = 32,
    color = "#1E160A",
    accent = "#A0622A"
}: SoundSpotsLogoProps) => {
    const markSize = size * 1.6;

    return (
        <HStack spacing={`${size * 0.3}px`} align={"center"}>
            <ArcMark size={markSize} accent={accent}/>
            <Box lineHeight={1}>
                <Text
                    color={color}
                    fontFamily={"Georgia, 'Times New Roman', serif"}
                    fontSize={`${size}px`}
                    fontWeight={400}
                    letterSpacing={"-0.01em"}
                    whiteSpace={"nowrap"}
                >
                    sound<Box as={"span"} marginLeft={"0.09em"}>spots</Box>
                </Text>
            </Box>
        </HStack>
    );
};

export default SoundSpotsLogo;
